// guards/ask-tawtheiq.guard.ts
import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AskTawtheiqAccessService } from '../other/ask-tawtheiq-access.service';

/**
 * Keeps external users off the Ask Tawtheiq full page (TAW-765).
 *
 * The button is disabled for them, so the only way here is a typed URL or a deep link
 * (e.g. a saved conversation). Send them to the dashboard instead of an empty chat that the
 * server would refuse to connect anyway.
 */
export const askTawtheiqRouteGuard = (): boolean | UrlTree => {
  const access = inject(AskTawtheiqAccessService);
  const router = inject(Router);

  if (access.canUse()) {
    return true;
  }

  return router.createUrlTree(['/main/dashboard']);
};
